/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-right': {
    width: 8,
    height: 13,
    viewBox: '0 0 8 13',
    data: '<path pid="0" d="M.048 1.658l4.758 4.436L.37 10.852l1.448 1.35 5.787-6.205L1.4.21z"/>'
  }
})
